export default __webpack_public_path__ + "assembly130baa38.png";